import { adminHttpClient } from '../commons/adminHttpClient'
import { PersonalDetailsValues } from 'application/employeeSignup/personalDetails'

const nonEEPersonalDetailsApi = (personalDetails: PersonalDetailsValues): Promise<any> => {
  return adminHttpClient.put('/NonEESignup/PersonalDetails', personalDetails)
}

export default nonEEPersonalDetailsApi
